import { memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import dayjs from 'dayjs';
import { getDateInText } from '@zmedia/bm-soccer-ui/utils/date';
import {
    Button,
    Element,
    Icon,
    IconButton,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import DatePicker from '@zmedia/bm-soccer-ui/modules/shared/components/DatePicker';
import styles from './style.module.scss';

interface IProps {
    date: string;
    isLive?: boolean;
}
export function DateChange({ date, isLive }: IProps) {
    const router = useRouter();
    const [show, setShow] = useState<boolean>(false);

    const goPrevDay = () => {
        const prevDay = dayjs(date).subtract(1, 'days').format('YYYY-MM-DD');
        router.push(`${URL_SOCCER_PAGE.LIVESCORE}?date=${prevDay}`);
    };

    const getPrevDay = () => {
        const prevDay = dayjs(date).subtract(1, 'days').format('YYYY-MM-DD');
        return `${URL_SOCCER_PAGE.LIVESCORE}?date=${prevDay}`;
    };

    const goNextDay = () => {
        const nextDay = dayjs(date).add(1, 'days').format('YYYY-MM-DD');
        router.push(`${URL_SOCCER_PAGE.LIVESCORE}?date=${nextDay}`);
    };

    const getNextDay = () => {
        const nextDay = dayjs(date).add(1, 'days').format('YYYY-MM-DD');
        return `${URL_SOCCER_PAGE.LIVESCORE}?date=${nextDay}`;
    };

    useEffect(() => {
        setShow(false);
    }, [router.asPath]);

    if (isLive) {
        return (
            <>
                <RouterLink to={getPrevDay()}>
                    <IconButton
                        icon="back-2"
                        onClick={goPrevDay}
                        title="Trước"
                    />
                </RouterLink>
                <Element
                    className={cn(
                        styles['datepicker-dropdown'],
                        styles['is-live']
                    )}
                >
                    <Button onClick={() => setShow(!show)}>
                        <Icon icon="calendar-day" />
                        <Icon icon={show ? 'up' : 'down'}></Icon>
                    </Button>
                    {show && (
                        <DatePicker
                            date={dayjs(date, 'YYYY-MM-DD').toDate()}
                            isSelected={false}
                        />
                    )}
                </Element>
                <RouterLink to={getNextDay()}>
                    <IconButton
                        icon="forward-2"
                        onClick={goNextDay}
                        title="Sau"
                    />
                </RouterLink>
            </>
        );
    }

    return (
        <>
            <RouterLink to={getPrevDay()}>
                <IconButton icon="back-2" onClick={goPrevDay} title="Trước" />
            </RouterLink>
            <Element className={styles['datepicker-dropdown']}>
                <Button onClick={() => setShow(!show)}>
                    {getDateInText(date)}
                    <Icon icon={show ? 'up' : 'down'}></Icon>
                </Button>
                {show && (
                    <DatePicker date={dayjs(date, 'YYYY-MM-DD').toDate()} />
                )}
            </Element>
            <RouterLink to={getNextDay()}>
                <IconButton icon="forward-2" onClick={goNextDay} title="Sau" />
            </RouterLink>
        </>
    );
}

export default memo(DateChange);
